import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {Moment} from "moment/moment";
import Cookies from 'js-cookie';

export interface IToken {
  access_token: string | null;
  token_type: string | null;
  expire: string | null;
  refresh_token: string | null;
  verification: string | null;
}

export const initialState: IToken = {
  access_token: null,
  token_type: null,
  expire: null,
  refresh_token: null,
  verification: null
};


const slice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    clear: (state: IRootState) => {
      state.access_token = null;
      state.token_type = null;
      state.expire = null;
      state.refresh_token = null;
      state.verification = null;
      Cookies.remove("access_token")
    },
    saveToken: (state: IRootState, action: PayloadAction<IToken>) => {
      state.access_token = action.payload.access_token;
      state.token_type = action.payload.token_type;
      state.expire = action.payload.expire;
      state.refresh_token = action.payload.refresh_token;
      state.verification = action.payload.verification;
      Cookies.set("access_token", `${action.payload.token_type} ${action.payload.access_token!}`, {expires: 1})
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
